import type { PropsWithChildren } from 'react';

import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';

import { TooltipProvider } from '../shadcn/tooltip';

import AuthProvider from './AuthProvider';
import EmailProvider from './EmailProvider/EmailProvider';
import { ModalsOutlet, ModalsProvider } from './ModalProvider/ModalProvider';
import OfficeProvider from './OfficeProvider';
import PostHogProvider from './PostHogProvider';
import QueryClientProvider from './QueryClientProvider';

export default function AppProviders({ children }: PropsWithChildren) {
  return (
    <PostHogProvider>
      <TooltipProvider>
        <QueryClientProvider>
          <OfficeProvider>
            <BrowserRouter>
              <AuthProvider>
                <ModalsProvider>
                  <EmailProvider>
                    <Toaster position="bottom-center" richColors />
                    {children}
                    <ModalsOutlet />
                  </EmailProvider>
                </ModalsProvider>
              </AuthProvider>
            </BrowserRouter>
          </OfficeProvider>
        </QueryClientProvider>
      </TooltipProvider>
    </PostHogProvider>
  );
}
